export default __webpack_public_path__ + "images/MB.6ec1075.png";